import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { fetchInterpretersList } from 'slices/interpreterSlice';
import { interpreterSelector } from 'slices/interpreterSlice';
import './SelectInterperter.css';
import { Controller } from 'react-hook-form';
import { Switch } from '@mui/material';

const ListInterperter = ({ setInterpreter, exclude_interpreter = false, autoSelectAll = false, language_id = null }) => {
    const dispatch = useDispatch();
    const { interpreter: interpreters, loader: loaderInterpreter } = useSelector(interpreterSelector);

    const [interpreterList, setInterpreterList] = useState([]);
    const [selectedInterpreters, setSelectedInterpreters] = useState([]);
    const [searchInput, setSearchInput] = useState("");

    // Fetch all interpreters on component mount and when `exclude_interpreter` changes
    useEffect(() => {
        const fetchAllInterpreters = async () => {
            try {
                const params = { pageLength: 1000, sortBy: "id", sortDirection: "asc", exclude_interpreter: exclude_interpreter ? 1 : 0, language_id: language_id };
                const result = await dispatch(fetchInterpretersList(1, params, true, true));
                if (result?.data) {
                    setInterpreterList(result.data);

                    // Auto-select all if autoSelectAll is true
                    if (autoSelectAll) {
                        const allIds = result.data.map(item => ({
                            value: item?.id,
                            label: item?.first_name,
                            id: item?.id,
                            name: item?.first_name
                        }));
                        setSelectedInterpreters(allIds);
                        setInterpreter({ interpreter_id: allIds });
                    } else {
                        // If exclude changed, clear selection to avoid selecting excluded interpreters
                        setSelectedInterpreters(prev => prev?.filter(p => result.data.some(r => r.id === p.id)) || []);
                        setInterpreter({ interpreter_id: selectedInterpreters?.filter(p => result.data.some(r => r.id === p.id)) || [] });
                    }
                }
            } catch (error) {
                console.error("Error fetching interpreters:", error);
            }
        };

        fetchAllInterpreters();
    }, [dispatch, exclude_interpreter]);

    // Handle individual checkbox selection
    const handleInterpreterToggle = (interpreter) => {
        const isSelected = selectedInterpreters.find(item => item.id === interpreter.id);
        
        let updatedList;
        if (isSelected) {
            updatedList = selectedInterpreters.filter(item => item.id !== interpreter.id);
        } else {
            updatedList = [...selectedInterpreters, {
                value: interpreter.id,
                label: interpreter.first_name,
                id: interpreter.id,
                name: interpreter.first_name
            }];
        }
        
        setSelectedInterpreters(updatedList);
        setInterpreter({ interpreter_id: updatedList });
    };

    // Filter interpreters based on search
    const filteredInterpreters = interpreterList.filter(interpreter =>
        interpreter.first_name?.toLowerCase().includes(searchInput.toLowerCase())
    );

    // Select all interpreters
    const handleSelectAll = () => {
        const allIds = filteredInterpreters.map(item => ({
            value: item?.id,
            label: item?.first_name,
            id: item?.id,
            name: item?.first_name
        }));
        setSelectedInterpreters(allIds);
        setInterpreter({ interpreter_id: allIds });
    };

    // Deselect all interpreters
    const handleDeselectAll = () => {
        setSelectedInterpreters([]);
        setInterpreter({ interpreter_id: [] });
    };

    return (
        
<>
            {loaderInterpreter && <p className="loading-text">Loading interpreters...</p>}

            <div className="interpreter-list">
                {filteredInterpreters.length > 0 ? (
                    filteredInterpreters.map((interpreter) => (
                        <div key={interpreter.id} className="interpreter-item">
                            <input
                                type="checkbox"
                                id={`interpreter-${interpreter.id}`}
                                checked={selectedInterpreters.some(item => item.id === interpreter.id)}
                                onChange={() => handleInterpreterToggle(interpreter)}
                                className="interpreter-checkbox"
                                disabled
                            />
                            <label htmlFor={`interpreter-${interpreter.id}`} className="interpreter-label">
                                {interpreter.first_name} {interpreter.last_name}
                            </label>
                        </div>
                    ))
                ) : (
                    <p className="no-results">No interpreters found</p>
                )}
            </div>

            <div className="interpreter-count">
                <p>{selectedInterpreters.length} interpreter(s) selected</p>
            </div>
            </>
    )
}

export default ListInterperter